import { currencyFormatter } from '@magalu/stereo-ui-utils';

const formatDiscountMessage = tags => {
  const {
    discountValue,
    discountType
  } = tags || {};
  if (typeof discountValue !== 'number' || discountValue <= 0) return null;
  const formattedDiscount = Math.trunc(discountValue);
  const formats = {
    percentage: `${formattedDiscount}% OFF`,
    absolute: `${currencyFormatter({
      value: formattedDiscount,
      decimal: false,
      locale: 'pt-br'
    }).replace(/\u00A0/g, ' ')} OFF`
  };
  return formats[discountType] || null;
};

export default formatDiscountMessage;